import React, { useState,useSelector,useEffect } from "react";
import {
  Button,
  Container
} from "reactstrap";
import OtpInput from '../../components/OtpInput/IndexOtpInput';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import Select from 'react-select'

import {
  getUserAll,
  addRoom,
  updateRoom
} from "../../actions";
// valid
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const RegisterSchema = Yup.object().shape({
  room_code: Yup.string() //ประเภทของข้อมูลคือ String
    .min(3, 'ชื่อสั้นเกินไป! ต้องมีอย่างน้อย 3 ตัวอักษร') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'ชื่อยาวเกินไป! ไม่เกิน 50 ตัวอักษร') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรองรหัส'), //ต้องกรอกช่องนี้
  room_name: Yup.string() //ประเภทของข้อมูลคือ String
    .min(3, 'ชื่อสั้นเกินไป! ต้องมีอย่างน้อย 3 ตัวอักษร') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'ชื่อยาวเกินไป! ไม่เกิน 50 ตัวอักษร') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรองรหัส') //ต้องกรอกช่องนี้
  
 
});

// core components
function RoomEdit({
  isInit,
  allUser,
  room,
  onSuccess
}) {

 

  const [users, setUsers] = useState([]);
  
  const [counselors, setCounselors] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [counselorSelected, setCounselorSelected] = useState({});
  const [supervisorSelected, setSupervisorSelected] = useState({});
  

  useEffect(() => {
   
    if (allUser.data && !allUser.isLoading && !allUser.isFailed) {
      setUsers(allUser.data.filter(counselor => {
        return counselor.userType === 1 ;
      }));
      setCounselors(allUser.data.filter(counselor => {
        // case 3: Counsellor;  
        // case 4: Supervisor; 
        return counselor.userType === 3 || counselor.userType === 4;
      }));
      
      setSupervisors(allUser.data.filter(counselor => {
        return counselor.userType === 4;
      }));
    }

    
  }, [allUser]);

  useEffect(() => {
    
    if (room && counselors && supervisors) {
      if(room.counsellor_uid){
        console.log(counselors)
        var c = counselors.find(obj => {
          return obj.value === room.counsellor_uid;
        })
        setCounselorSelected(c)
      }
      if(room.supervisor_uid){
        var s = supervisors.find(obj => {
          return obj.value === room.supervisor_uid;
        })
        setSupervisorSelected(s);
      }
    }
    
  }, [supervisors,counselors,room]);
  

  const isNumber = (text) => {
    let value = '';
    let valid = false;
    let numbers = '0123456789';
    for (var i = 0; i < text.length; i++) {
      if (numbers.indexOf(text[i]) > -1) {
        value = value + text[i];
        valid = true
      }
      else {
        valid = false
      }
    }
    return { value, valid }

  }

  

  

  const _onSubmit = (data) => {

    if(counselorSelected){
      data.counsellor_uid = counselorSelected.value;
    }
    if(supervisorSelected){
      data.supervisor_uid = supervisorSelected.value;
    }
    
    if(isInit){
      addRoom(data).then((res) => {
        if (res) {
          var index = res.toString().indexOf("Error:")
          if (index == -1) {
            onSuccess(true)
          } else {
            onSuccess(false)
          }
        } else {
          onSuccess(false)
        }
      }).catch((error) => {
  
      })
    }else{
      updateRoom(data).then((res) => {
        if (res) {
          var index = res.toString().indexOf("Error:")
          if (index == -1) {
            onSuccess(true)
          } else {
            onSuccess(false)
          }
        } else {
          onSuccess(false)
        }
      }).catch((error) => {
  
      })
    }
   
  }

  return (
    <Container>
      <div>
        <Formik
          initialValues={isInit?{
            room_code: '',
            room_name: '',
            counsellor_uid: '',
            supervisor_uid: '',
          }:room}
          validationSchema={RegisterSchema}
          onSubmit={(e) => _onSubmit(e)}
        >
          {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
            <Form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-group">

                <label htmlFor="room_code" >
                  รหัสห้อง
                             </label>
                <Field
                  name="room_code"
                  type="text"
                  className={`form-control ${touched.room_code ? errors.room_code ? 'is-invalid' : 'is-valid' : ''}`}
                  id="room_code"
                  placeholder="กรอกรหัสห้อง"
                />
                <ErrorMessage component="div" name="room_code" className="invalid-feedback" />
              </div>

              <div className="form-group">

                <label htmlFor="room_name" >
                  ชื่อห้อง
                            </label>
                <Field
                  name="room_name"
                  type="text"
                  className={`form-control ${touched.room_name ? errors.room_name ? 'is-invalid' : 'is-valid' : ''}`}
                  id="room_name"
                  placeholder="กรอกชื่อห้อง"
                />
                <ErrorMessage component="div" name="room_name" className="invalid-feedback" />
              </div>

              <div className="form-group">

                <label>
                  นักจิตวิทยา/นักศึกษาจิตวิทยา/ผู้ให้บริการ
                </label>
                <Select value={counselorSelected}  options={counselors} onChange={(event) => setCounselorSelected(event)} />
                
              </div>
              
              <div className="form-group">

                <label>
                  อาจารย์/ผู้นิเทศ/ผู้รับผิดชอบ
                </label>
                <Select value={supervisorSelected} options={supervisors} onChange={(event) => setSupervisorSelected(event)} />

              </div>
             
              <div className="row">
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="submit" className="btn-round" color="info" style={{ width: '80%' }}>บันทึก</Button>
                </div>
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="reset" className="btn-round" color="primary" style={{ width: '50%' }}>ล้างค่า</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default RoomEdit;
